import { AnyAction } from 'redux'

interface CustomerNameState {
  name: string
}

const noCustomerName: CustomerNameState = {
  name: '',
}

const customerName = (state = noCustomerName, action: AnyAction) => {
  switch (action.type) {
    case 'SET_CUSTOMER_NAME':
      const newState = {
        name: action.name,
      }

      return {
        ...state,
        ...newState,
      }

    default:
      return state
  }
}

export default customerName
